import { combineReducers } from 'redux'
import reducerRotator from './reducerRotator'
import reducerHouses from './reducerHouses'
import reducerMasks from './reducerMasks'
export default combineReducers({
  rotator: reducerRotator,
  houses: reducerHouses,
  masks: reducerMasks
})
